import React from 'react';
import { Trophy } from 'lucide-react';

export default function TierBadge({ tier, size = 'md', showLabel = true }) {
  const tierConfig = {
    gold: {
      bg: 'bg-gradient-to-r from-[#D4AF37] to-[#F5D76E]',
      text: 'text-[#0A0A0A]',
      glow: 'shadow-[0_0_20px_rgba(212,175,55,0.4)]',
      label: 'Gold'
    },
    silver: {
      bg: 'bg-gradient-to-r from-[#C0C0C0] to-[#E8E8E8]',
      text: 'text-[#0A0A0A]',
      glow: 'shadow-[0_0_20px_rgba(192,192,192,0.4)]',
      label: 'Silver'
    },
    bronze: {
      bg: 'bg-gradient-to-r from-[#CD7F32] to-[#E5A055]',
      text: 'text-[#0A0A0A]',
      glow: 'shadow-[0_0_20px_rgba(205,127,50,0.4)]',
      label: 'Bronze'
    }
  };

  const sizeClasses = {
    sm: 'px-2 py-0.5 text-xs',
    md: 'px-3 py-1 text-sm',
    lg: 'px-4 py-1.5 text-base'
  };

  const iconSizes = {
    sm: 'w-3 h-3',
    md: 'w-4 h-4',
    lg: 'w-5 h-5'
  };

  const config = tierConfig[tier?.toLowerCase()] || tierConfig.bronze;

  return (
    <div
      className={`inline-flex items-center gap-1.5 rounded-full font-semibold ${config.bg} ${config.text} ${config.glow} ${sizeClasses[size]}`}
      data-testid={`tier-badge-${tier?.toLowerCase()}`}
    >
      <Trophy className={iconSizes[size]} />
      {showLabel && <span>{config.label}</span>}
    </div>
  );
}
